import { useMemo, useState } from "react";
import API from "../utils/API";
import Sweetalert from "../utils/Sweetalert";
import Select from "./Select";
import useFeatureFlag, { FEATURE_CODES } from "../hooks/useFeatureFlag";

export default function TotemManageDetailsForm({
  totem,
  teams,
  updateTotem,
  setEditTotem,
}) {
  const [totemName, setTotemName] = useState("");
  const [displayAddress, setDisplayAddress] = useState("");
  const [displayAgency, setDisplayAgency] = useState("");
  const [displayCode, setDisplayCode] = useState("");
  const [displayCity, setDisplayCity] = useState("");
  const [displayZipCode, setDisplayZipCode] = useState("");
  const [displayFormat, setDisplayFormat] = useState("");
  const [displayIndoor, setDisplayIndoor] = useState("");
  const [displayPosition, setDisplayPosition] = useState("");
  const [displayType, setDisplayType] = useState("");
  const [displayAudience, setDisplayAudience] = useState("");
  const [displaySpot, setDisplaySpot] = useState("");
  const [displayDiffusion, setDisplayDiffusion] = useState("");
  const [displayLat, setDisplayLat] = useState("");
  const [displayLong, setDisplayLong] = useState("");
  const [displayPrice1, setDisplayPrice1] = useState("");
  const [displayPrice2, setDisplayPrice2] = useState("");
  const [displayPrice3, setDisplayPrice3] = useState("");
  const [displayTlpe, setDisplayTlpe] = useState("");
  const [displaySector, setDisplaySector] = useState("");
  const [displayZoneType, setDisplayZoneType] = useState("");
  const [displayCommercial, setDisplayCommercial] = useState("");
  const [displayTel, setDisplayTel] = useState("");
  const [displayDescription, setDisplayDescription] = useState("");
  const [displayImageUrl, setDisplayImageUrl] = useState("");
  const [totemIsLed, setTotemIsLed] = useState("");
  const [totemWidth, setTotemWidth] = useState("");
  const [totemHeight, setTotemHeight] = useState("");
  const [totemWidthOffset, setTotemWidthOffset] = useState("");
  const [totemHeightOffset, setTotemHeightOffset] = useState("");
  const [totemHasNav, setTotemHasNav] = useState(false);
  const [totemNavTeamId, setTotemNavTeamId] = useState("");
  const [totemLatitude, setTotemLatitude] = useState("");
  const [totemLongitude, setTotemLongitude] = useState("");
  const [totemLink, setTotemLink] = useState("");
  const [totemAwakeTime, setTotemAwakeTime] = useState(0);
  const [powerOffTime, setPowerOffTime] = useState("00:00");
  const [powerOnTime, setPowerOnTime] = useState("00:00");
  const [powerOnOffAdvanced, setPowerOnOffAdvanced] = useState(false);
  const [powerOffTimeArray, setPowerOffTimeArray] = useState([
    "00:00",
    "00:00",
    "00:00",
    "00:00",
    "00:00",
    "00:00",
    "00:00",
  ]);
  const [powerOnTimeArray, setPowerOnTimeArray] = useState([
    "00:00",
    "00:00",
    "00:00",
    "00:00",
    "00:00",
    "00:00",
    "00:00",
  ]);
  const [totemHasAiTargeting, setTotemHasAiTargeting] = useState(false);
  const [error, setError] = useState("");
  const { isActive: isAiTargetingFeatureActive } = useFeatureFlag(FEATURE_CODES.AI_TARGETING);

  // Comportements
  useMemo(() => {
    setTotemName(totem.name);
    if (totem.display) {
      setDisplayAddress(totem.display.address || "");
      setDisplayAgency(totem.display.agency || "");
      setDisplayCode(totem.display.code || "");
      setDisplayCity(totem.display.city || "");
      setDisplayZipCode(totem.display.zip_code || "");
      setDisplayFormat(totem.display.format || "");
      setDisplayIndoor(totem.display.indoor || "");
      setDisplayPosition(totem.display.position || "");
      setDisplayType(totem.display.type || "");
      setDisplayAudience(totem.display.audience || "");
      setDisplaySpot(totem.display.spot || "");
      setDisplayDiffusion(totem.display.diffusion || "");
      setDisplayLat(totem.display.lat || "");
      setDisplayLong(totem.display.long || "");
      setDisplayPrice1(totem.display.price_1 || "");
      setDisplayPrice2(totem.display.price_2 || "");
      setDisplayPrice3(totem.display.price_3 || "");
      setDisplayTlpe(totem.display.tlpe || "");
      setDisplaySector(totem.display.sector || "");
      setDisplayZoneType(totem.display.zone_type || "");
      setDisplayCommercial(totem.display.commercial || "");
      setDisplayTel(totem.display.tel || "");
      setDisplayDescription(totem.display.description || "");
      setDisplayImageUrl(totem.display.image_url || "");
    }
    setTotemIsLed(totem.isLed);
    setTotemWidth(totem.width);
    setTotemHeight(totem.height);
    setTotemWidthOffset(totem.widthOffset);
    setTotemHeightOffset(totem.heightOffset);
    setTotemHasNav(totem.hasNav);
    setTotemNavTeamId(totem.navTeamId);
    setTotemLink(totem.link || "");
    setTotemAwakeTime(totem.awakeTime);
    setTotemLatitude(totem.latitude || "");
    setTotemLongitude(totem.longitude || "");
    setTotemHasAiTargeting(totem.hasAiTargeting || false);
    if (totem.powerOffTime.length > 5 && totem.powerOnTime.length > 5) {
      // Advanced
      setPowerOnOffAdvanced(true);
      setPowerOffTimeArray(totem.powerOffTime.split("."));
      setPowerOnTimeArray(totem.powerOnTime.split("."));
    } else {
      // Simple
      setPowerOffTime(totem.powerOffTime);
      setPowerOnTime(totem.powerOnTime);
    }
  }, [totem]);

  const interactiveTeams = useMemo(() => {
    return teams.filter(
      (team) => team.establishmentType && team.establishmentType.id === 2
    ); // filtre sur les équipes interactives
  }, [teams]);

  const updateAdvancedTimeOff = (index, value) => {
    let powerOffTimeArrayCopy = [...powerOffTimeArray];
    powerOffTimeArrayCopy[index] = value;
    setPowerOffTimeArray(powerOffTimeArrayCopy);
  };

  const updateAdvancedTimeOn = (index, value) => {
    let powerOnTimeArrayCopy = [...powerOnTimeArray];
    powerOnTimeArrayCopy[index] = value;
    setPowerOnTimeArray(powerOnTimeArrayCopy);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setError("");

    Sweetalert.fireConfirm(
      "Validez vous cette mise à jour ?",
      "Le totem se mettra à jour automatiquement, instantanément ou à sa prochaine reconnexion",
      () => {
        let pOffTime = powerOffTime;
        let pOnTime = powerOnTime;
        if (powerOnOffAdvanced) {
          pOffTime = powerOffTimeArray.join(".");
          pOnTime = powerOnTimeArray.join(".");
        }
        let data = {
          name: totemName,
          isLed: totemIsLed,
          width: totemWidth,
          height: totemHeight,
          widthOffset: totemWidthOffset,
          heightOffset: totemHeightOffset,
          hasNav: totemHasNav,
          navTeamId: totemNavTeamId,
          latitude: totemLatitude !== "" ? totemLatitude : null,
          longitude: totemLongitude !== "" ? totemLongitude : null,
          link: totemLink !== "" && totem.establishmentTypeId === 1 ? totemLink : null,
          awakeTime: totemAwakeTime,
          powerOffTime: pOffTime,
          powerOnTime: pOnTime,
          hasAiTargeting: totemHasAiTargeting,
          display: {
            agency: displayAgency || null,
            code: displayCode || null,
            address: displayAddress || null,
            city: displayCity || null,
            zip_code: displayZipCode || null,
            format: displayFormat || null,
            indoor: displayIndoor || null,
            position: displayPosition || null,
            type: displayType || null,
            audience: displayAudience || null,
            spot: displaySpot || null,
            diffusion: displayDiffusion || null,
            lat: displayLat || null,
            long: displayLong || null,
            price_1: displayPrice1 || null,
            price_2: displayPrice2 || null,
            price_3: displayPrice3 || null,
            tlpe: displayTlpe || null,
            sector: displaySector || null,
            zone_type: displayZoneType || null,
            commercial: displayCommercial || null,
            tel: displayTel || null,
            description: displayDescription || null,
            image_url: displayImageUrl || null,
          },
        };

        API.PUT("/admin/totem/" + totem.id, data, (response) => {
          Sweetalert.fireSuccessToast(response.data.message);
          updateTotem(data);
          setEditTotem(false);
        });
      }
    );
  };

  // Rendu
  return (
    <div className="card card-light">
      <div className="card-header">
        <h3 className="card-title">Édition de l'écran : {totem.id}</h3>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="card-body">
          <h5 className="mb-3">Informations de l'emplacement</h5>
          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label>Agence</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Agence"
                  value={displayAgency}
                  onChange={(event) => setDisplayAgency(event.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Code</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Code"
                  value={displayCode}
                  onChange={(event) => setDisplayCode(event.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Adresse de l'écran (optionnel)</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Adresse"
                  value={displayAddress}
                  pattern="[a-zA-Z0-9áàâäçéèêëíìîïñóòôöúùûüýÿæœ, ]{1,255}"
                  title="Chiffres, lettres, espaces ou virgules entre 1 et 255 caractères"
                  onChange={(event) => {
                    setDisplayAddress(event.target.value);
                  }}
                />
              </div>
              <div className="form-group">
                <label>Ville</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Ville"
                  value={displayCity}
                  onChange={(event) => setDisplayCity(event.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Code postal</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Code postal"
                  value={displayZipCode}
                  onChange={(event) => setDisplayZipCode(event.target.value)}
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>Format</label>
                <select
                  className="form-control"
                  value={displayFormat}
                  onChange={(event) => setDisplayFormat(event.target.value)}
                >
                  <option value="">-- Sélectionner un format --</option>
                  <option value="1m2">1m2</option>
                  <option value="2m2">2m2</option>
                  <option value="4m2">4m2</option>
                  <option value="6m2">6m2</option>
                  <option value="8m2">8m2</option>
                  <option value="12m2">12m2</option>
                </select>
              </div>
              <div className="form-group">
                <label>Indoor</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Indoor"
                  value={displayIndoor}
                  onChange={(event) => setDisplayIndoor(event.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Position</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Position"
                  value={displayPosition}
                  onChange={(event) => setDisplayPosition(event.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Type</label>
                <select
                  className="form-control"
                  value={displayType}
                  onChange={(event) => setDisplayType(event.target.value)}
                >
                  <option value="">-- Sélectionner un type --</option>
                  <option value="Digital">Digital</option>
                  <option value="Print">Print</option>
                </select>
              </div>
              <div className="form-group">
                <label>Audience</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Audience"
                  value={displayAudience}
                  onChange={(event) => setDisplayAudience(event.target.value)}
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>Spot</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Spot"
                  value={displaySpot}
                  onChange={(event) => setDisplaySpot(event.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Diffusion</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Diffusion"
                  value={displayDiffusion}
                  onChange={(event) => setDisplayDiffusion(event.target.value)}
                />
              </div>
              <div className="form-group">
                <label>TLPE</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="TLPE"
                  value={displayTlpe}
                  onChange={(event) => setDisplayTlpe(event.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Secteur</label>
                <select
                  className="form-control"
                  value={displaySector}
                  onChange={(event) => setDisplaySector(event.target.value)}
                >
                  <option value="">-- Sélectionner un secteur --</option>
                  <option value="Casino">Casino</option>
                  <option value="Centre ville">Centre ville</option>
                  <option value="Cinema">Cinema</option>
                  <option value="Grande surface">Grande surface</option>
                  <option value="Routier">Routier</option>
                  <option value="Tennis club">Tennis club</option>
                  <option value="Village vacances">Village vacances</option>
                </select>
              </div>
              <div className="form-group">
                <label>Type de zone</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Type de zone"
                  value={displayZoneType}
                  onChange={(event) => setDisplayZoneType(event.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <div className="form-group">
                <label>Latitude</label>
                <input
                  type="number"
                  step="any"
                  className="form-control"
                  placeholder="Latitude"
                  value={displayLat}
                  onChange={(event) => setDisplayLat(event.target.value)}
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label>Longitude</label>
                <input
                  type="number"
                  step="any"
                  className="form-control"
                  placeholder="Longitude"
                  value={displayLong}
                  onChange={(event) => setDisplayLong(event.target.value)}
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label>Commercial</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Commercial"
                  value={displayCommercial}
                  onChange={(event) => setDisplayCommercial(event.target.value)}
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label>Téléphone</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Téléphone"
                  value={displayTel}
                  onChange={(event) => setDisplayTel(event.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label>Prix 1</label>
                <input
                  type="number"
                  step="0.01"
                  className="form-control"
                  placeholder="Prix 1"
                  value={displayPrice1}
                  onChange={(event) => setDisplayPrice1(event.target.value)}
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>Prix 2</label>
                <input
                  type="number"
                  step="0.01"
                  className="form-control"
                  placeholder="Prix 2"
                  value={displayPrice2}
                  onChange={(event) => setDisplayPrice2(event.target.value)}
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>Prix 3</label>
                <input
                  type="number"
                  step="0.01"
                  className="form-control"
                  placeholder="Prix 3"
                  value={displayPrice3}
                  onChange={(event) => setDisplayPrice3(event.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label>Description</label>
                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Description de l'emplacement"
                  value={displayDescription}
                  onChange={(event) => setDisplayDescription(event.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label>Image URL</label>
                <input
                  type="url"
                  className="form-control"
                  placeholder="https://exemple.com/image.jpg"
                  value={displayImageUrl}
                  onChange={(event) => setDisplayImageUrl(event.target.value)}
                />
              </div>
            </div>
          </div>
          <hr className="my-4" />
          <h5 className="mb-3">Configuration de l'écran</h5>
          <div className="row">
            <div className="col">
              <div className="form-group">
                <label>Nom de l'écran</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Nom"
                  value={totemName}
                  required
                  pattern="[a-zA-Z0-9\-áàâäçéèêëíìîïñóòôöúùûüýÿæœ ]{1,255}"
                  title="Chiffres, lettres, espaces ou tiret (-)"
                  onChange={(event) => {
                    setTotemName(event.target.value);
                  }}
                />
              </div>
              <div className="form-group">
                <label>Écran LED</label>
                <div className="form-check">
                  <label
                    className="form-check-label"
                    style={{ cursor: "pointer" }}
                  >
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={totemIsLed}
                      onChange={() => setTotemIsLed(!totemIsLed)}
                    />
                    Mode écran LED
                  </label>
                </div>
              </div>
              <div className="form-group">
                <label>Taille de l'écran</label>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Largeur en pixel >= 0"
                    value={totemWidth}
                    min="0"
                    onChange={(event) => {
                      setTotemWidth(event.target.value);
                    }}
                  />
                  <label style={{ margin: "0 20px", textAlign: "center" }}>
                    x
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Hauteur en pixel >= 0"
                    value={totemHeight}
                    min="0"
                    onChange={(event) => {
                      setTotemHeight(event.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="form-group">
                <label>Offset (décalage d'affichage)</label>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Vectical en pixel"
                    value={totemWidthOffset}
                    min="0"
                    onChange={(event) => {
                      setTotemWidthOffset(event.target.value);
                    }}
                  />
                  <label style={{ margin: "0 20px", textAlign: "center" }}>
                    x
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Horizontal en pixel"
                    value={totemHeightOffset}
                    min="0"
                    onChange={(event) => {
                      setTotemHeightOffset(event.target.value);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col">
              <div className="form-group">
                <label>Navigation interractive</label>
                <div className="form-check">
                  <label
                    className="form-check-label"
                    style={{ cursor: "pointer" }}
                  >
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={totemHasNav}
                      onChange={() => setTotemHasNav(!totemHasNav)}
                    />
                    Activé
                  </label>
                </div>
              </div>
              {totem.establishmentTypeId === 1 && totemHasNav && (
                <div className="form-group">
                  <label>Lien de l'office de tourisme</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="https://office-de-tourisme-exemple.fr"
                    value={totemLink}
                    pattern="https:\/\/[a-zA-Z0-9:_\-.\/]{1,240}"
                    title="Lien d'un site internet commençant par https (sécurisé)"
                    required
                    onChange={(event) => {
                      setTotemLink(event.target.value);
                    }}
                  />
                </div>
              )}
              {totem.establishmentTypeId === 2 && totemHasNav && (
                <div className="form-group">
                  <label>Équipe gérant le contenu interactif</label>
                  <Select
                    onChange={setTotemNavTeamId}
                    options={interactiveTeams}
                    defaultValue={totemNavTeamId}
                    name="totemNavTeam"
                  />
                </div>
              )}
              <div className="form-group">
                <label>Coordonnées GPS - Latitude</label>
                <input
                  type="number"
                  className="form-control"
                  value={totemLatitude}
                  step="any"
                  onChange={(event) => {
                    setTotemLatitude(event.target.value)
                  }}
                />
              </div>
              <div className="form-group">
                <label>Coordonnées GPS - Longitude</label>
                <input
                  type="number"
                  className="form-control"
                  value={totemLongitude}
                  step="any"
                  onChange={(event) => {
                    setTotemLongitude(event.target.value)
                  }}
                />
              </div>
            </div>
            <div className="col">
              <div className="form-group">
                <label>Durée avant la veille</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder=">= 1"
                  value={totemAwakeTime}
                  min="1"
                  onChange={(event) => {
                    setTotemAwakeTime(event.target.value);
                  }}
                />
              </div>
              <div className="row">
                {powerOnOffAdvanced ? (
                  <>
                    <div className="col">
                      <div className="form-group">
                        <label>Écran On (L -&gt; D)</label>
                        <input
                          type="time"
                          className="form-control mb-1"
                          value={powerOnTimeArray[1]}
                          onChange={(event) => {
                            updateAdvancedTimeOn(1, event.target.value);
                          }}
                        />
                        <input
                          type="time"
                          className="form-control mb-1"
                          value={powerOnTimeArray[2]}
                          onChange={(event) => {
                            updateAdvancedTimeOn(2, event.target.value);
                          }}
                        />
                        <input
                          type="time"
                          className="form-control mb-1"
                          value={powerOnTimeArray[3]}
                          onChange={(event) => {
                            updateAdvancedTimeOn(3, event.target.value);
                          }}
                        />
                        <input
                          type="time"
                          className="form-control mb-1"
                          value={powerOnTimeArray[4]}
                          onChange={(event) => {
                            updateAdvancedTimeOn(4, event.target.value);
                          }}
                        />
                        <input
                          type="time"
                          className="form-control mb-1"
                          value={powerOnTimeArray[5]}
                          onChange={(event) => {
                            updateAdvancedTimeOn(5, event.target.value);
                          }}
                        />
                        <input
                          type="time"
                          className="form-control mb-1"
                          value={powerOnTimeArray[6]}
                          onChange={(event) => {
                            updateAdvancedTimeOn(6, event.target.value);
                          }}
                        />
                        <input
                          type="time"
                          className="form-control"
                          value={powerOnTimeArray[0]}
                          onChange={(event) => {
                            updateAdvancedTimeOn(0, event.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col">
                      <div className="form-group">
                        <label>Écran Off (L -&gt; D)</label>
                        <input
                          type="time"
                          className="form-control mb-1"
                          value={powerOffTimeArray[1]}
                          onChange={(event) => {
                            updateAdvancedTimeOff(1, event.target.value);
                          }}
                        />
                        <input
                          type="time"
                          className="form-control mb-1"
                          value={powerOffTimeArray[2]}
                          onChange={(event) => {
                            updateAdvancedTimeOff(2, event.target.value);
                          }}
                        />
                        <input
                          type="time"
                          className="form-control mb-1"
                          value={powerOffTimeArray[3]}
                          onChange={(event) => {
                            updateAdvancedTimeOff(3, event.target.value);
                          }}
                        />
                        <input
                          type="time"
                          className="form-control mb-1"
                          value={powerOffTimeArray[4]}
                          onChange={(event) => {
                            updateAdvancedTimeOff(4, event.target.value);
                          }}
                        />
                        <input
                          type="time"
                          className="form-control mb-1"
                          value={powerOffTimeArray[5]}
                          onChange={(event) => {
                            updateAdvancedTimeOff(5, event.target.value);
                          }}
                        />
                        <input
                          type="time"
                          className="form-control mb-1"
                          value={powerOffTimeArray[6]}
                          onChange={(event) => {
                            updateAdvancedTimeOff(6, event.target.value);
                          }}
                        />
                        <input
                          type="time"
                          className="form-control"
                          value={powerOffTimeArray[0]}
                          onChange={(event) => {
                            updateAdvancedTimeOff(0, event.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="col">
                      <div className="form-group">
                        <label>Écran On</label>
                        <input
                          type="time"
                          className="form-control"
                          value={powerOnTime}
                          onChange={(event) => {
                            setPowerOnTime(event.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col">
                      <div className="form-group">
                        <label>Écran Off</label>
                        <input
                          type="time"
                          className="form-control"
                          value={powerOffTime}
                          onChange={(event) => {
                            setPowerOffTime(event.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className="form-group">
                <label>Configuration écran</label>
                <div className="form-check">
                  <label
                    className="form-check-label"
                    style={{ cursor: "pointer" }}
                  >
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={powerOnOffAdvanced}
                      onChange={() =>
                        setPowerOnOffAdvanced(!powerOnOffAdvanced)
                      }
                    />
                    Avancée
                  </label>
                </div>
              </div>
              {isAiTargetingFeatureActive && (
                <div className="form-group">
                  <label>Module Ciblage IA</label>
                  <div className="form-check">
                    <label
                      className="form-check-label"
                      style={{ cursor: "pointer" }}
                    >
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={totemHasAiTargeting}
                        onChange={() =>
                          setTotemHasAiTargeting(!totemHasAiTargeting)
                        }
                      />
                      Activé
                    </label>
                  </div>
                </div>
              )}
            </div>
          </div>
          <p className="text-danger">{error}</p>
        </div>
        <div className="card-footer">
          <button type="submit" className="btn btn-primary">
            Valider
          </button>
          <button
            type="button"
            className="btn btn-default float-right"
            onClick={() => setEditTotem(false)}
          >
            Annuler
          </button>
        </div>
      </form>
    </div>
  );
}
